<template>
	<div>
		<Layout :navFixed="true" :transparent="true">
			<div class="mainSlider"></div>
			<div class="search-box">
				<div class="box">
					Buscador por nombre y categoria de evento
				</div>
			</div>

			<div class="container mt-3">
				<div class="row">
					<div class="col-12 col-sm-6 col-md-4 col-lg-4 " v-for="item in list" :key="item.id">
						<div>
							<EventItem :event="item" />
						</div>
					</div>
				</div>
			</div>
		</Layout>
	</div>
</template>

<script>
import gql from "graphql-tag"
import Layout from "@/components/Layout"
import EventItem from "@/views/events/EventItem"

export default {
	name: "Home",
	components: {
		Layout,
		EventItem
	},
	data() {
		return {
			loading: false,
			list: []
		}
	},

	async beforeMount() {
		this.filters = this.getValidUrlParams()
		await this.load()
	},

	methods: {
		load() {
			this.loading = true
			return this.$apollo
				.query({
					query: gql`
						query($take: Int, $skip: Int, $search: String) {
							events(take: $take, skip: $skip, search: $search) {
								data {
									id
									code
									name
									startAt
									endAt
									description
									image {
										id
										type
										filename
										url
										urlThumb
									}
									location {
										id
										name
										locality {
											name
											region {
												name
											}
										}
										address
										latlng {
											lat
											lng
										}
									}

									status
									statusText
									statusClass
								}
								pageInfo {
									totalItems
								}
							}
						}
					`,
					variables: {
						take: this.pagination.length,
						skip: this.pagination.skip,
						search: this.filters.search
					},
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.list = data.events.data
					this.pagination.pageInfo = data.events.pageInfo
					this.loading = false
				})
		}
	}
}
</script>

<style scoped lang="scss">
.mainSlider {
	background-color: #333;
	width: 100%;
	padding-top: 29.5%;
	background-image: url("~@/assets/img/home-banner-01.jpeg");
	background-size: cover;
	background-position: center center;
}

.search-box {
	max-width: 1140px;
	width: 100%;
	margin: -30px auto 0 auto;
	padding: 0px 15px;
	.box {
		border-radius: 8px;
		height: 80px;
		background-color: #fff;
		display: flex;
		flex: 1 1 0%;
		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
		padding: 0px;
	}
}
</style>
